import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const wrapper = css`
    margin: 1rem;
    .row,
    .col {
      margin: 0;
    }
    .col {
      padding: 0;
    }
  `;

  const header = css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  `;

  const title = css`
    ${theme.typography.h1}
    color: ${theme.colors.navy["1"]};
    margin: 0;
  `;

  const line = css`
    background-color: ${theme.colors.gray["2"]};
    margin: 1rem 0;
    width: 100%;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
    padding: 1.25em 1em;
  `;

  const toolbar = css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
  `;

  const search = css`
    flex: 1 1 16rem;
    max-width: 28rem;
  `;

  const muted = css`
    color: ${theme.colors.gray.primary};
    font-size: 0.875rem;
  `;

  const tree = css`
    list-style: none;
    margin: 0;
    padding: 0;
    ul {
      list-style: none;
      margin: 0;
      padding-left: 1.25rem;
      border-left: 1px solid ${theme.colors.gray["2"]};
    }
  `;

  const row = css`
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 0.8125rem;
    color: ${theme.colors.navy["1"]};
    cursor: pointer;
    &:hover,
    &:focus-visible {
      background: ${theme.colors.gray["6"]};
    }
    mark {
      padding: 0;
      background: #fff3a3;
    }
  `;

  const key = css`
    font-weight: 600;
  `;

  const value = css`
    white-space: pre-wrap;
    word-break: break-word;
  `;

  const badge = css`
    color: ${theme.colors.gray.primary};
    font-size: 0.75rem;
  `;

  const more = css`
    background: none;
    border: none;
    padding: 0;
    color: ${theme.colors.teal["1"]};
    text-decoration: underline;
    font-size: 0.75rem;
  `;

  return {
    wrapper,
    header,
    title,
    line,
    card,
    toolbar,
    search,
    muted,
    tree,
    row,
    key,
    value,
    badge,
    more,
  };
};

export default useStyles;
